module.exports = __webpack_public_path__ + "src/assets/images/checkmark-icon.833907cf94ecfbf6a6b5cfa7f3502817.svg";